

export function syncPiecesFromHistory({ ref }) {

  const { puzzle, info } = ref;
  if (!puzzle.state.isInitialized || !puzzle.state.boardDimensions?.width) {
      setTimeout(ref.puzzle.methods.syncPiecesFromHistory, 150); return;
  }

  const placedPiecesMap = info.game?.puzzle?.placedPieces || {};
  let needsRender = false;

  Object.keys(placedPiecesMap).forEach(pieceId => {

      const placedPieceData = placedPiecesMap[pieceId];
      const userId = placedPieceData?.userId;
      if (!userId) return;
      const piece = puzzle.state.pieces[pieceId];
      if (piece && !piece.placed) {

          const placed = puzzle.methods._placePiece(pieceId, userId);
          if (placed) needsRender = true; // Отмечаем, что изменения были
      } else if (piece && piece.placed && piece.placedBy !== userId) {
          piece.placedBy = userId; needsRender = true;
      }

  });

  // Обновляем счетчик один раз
  if (needsRender) {
      puzzle.methods.redraw();
      window.croco?.log(`Synced placed pieces from history.`);
  } 
  
  puzzle.methods.clearTrayGhosts();
  puzzle.methods.checkCompletion();


}
